<template>
	<span
		class="rounded px-1 py-0.5 text-xs font-semibold"
		:class="getSeverityColorClass(severity)"
	>
		{{ severity }}/10
	</span>
</template>

<script setup lang="ts">
	interface Props {
		severity?: number;
	}

	withDefaults(defineProps<Props>(), {
		severity: 5,
	});

	const getSeverityColorClass = (severity: number): string => {
		if (severity <= 3) return "bg-green-100 text-green-800";
		if (severity <= 6) return "bg-yellow-100 text-yellow-800";
		if (severity <= 8) return "bg-orange-100 text-orange-800";
		return "bg-red-100 text-red-800";
	};
</script>
